export default {
    nodes: [
        {
            label: 'Dashboard',
            route: {name: 'dashboard'},
            icon: 'dashboard',
        },
        {
            label: 'Lists',
            route: {name: 'lists'},
            icon: 'lists',
        },
        {
            label: 'Automations',
            route: {name: 'automations'},
            icon: 'automation',
        },
    ],
};
